export default __webpack_public_path__ + "static/media/fa-brands-400.ecbd4c55.woff";